import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import Unauthorized from "@/pages/auth/Unauthorized";


const ProtectedRoute = ({ children, requiredPage }) => {
  const { isAuthenticated, loading, hasPermission } = useAuthStore();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredPage && !hasPermission(requiredPage)) {
    return <Unauthorized />;
  }

  return children || <Outlet />;
};

export default ProtectedRoute;
